import { IDENTITY_PATHS, identityAuthUrl, PLAY_PATHS } from '@words-happen/app-urls';

/** The identity app's /sign-out, returning to this app's home: id.<domain>/sign-out?return_to=play.<domain>/. */
export const signOutUrl = (identityOrigin: string = IDENTITY_URL, playOrigin: string = PLAY_URL): string =>
  identityAuthUrl(identityOrigin, IDENTITY_PATHS.signOut, { returnTo: new URL(PLAY_PATHS.home, playOrigin).href });
